'use strict';

const SectionsContainer = require('./SectionsContainer');

/**
 * Clase de gestión de una sección del CRF
 * @extends SectionsContainer
 * @memberOf Structure
 */
class Section extends SectionsContainer {
    /**
     * En el constructor se inicializa la propiedad "sections" si no está definida
     * @param  {object} jsonDefinition Definición del contenedor de secciones
     */
    constructor(jsonDefinition = {}) {
        super(jsonDefinition);
        this.scheduledVisit = {
            enabled: false,
            notifications: [],
            ...jsonDefinition.scheduledVisit || {},
        };
    }

    /**
     * Determina si el objeto es de tipo sección
     * @return {boolean} Verdadero siempre
     */
    isSection() {
        return true;
    }

    /**
     * Is scheduled visit enabled
     *
     * @returns {boolean} Whether the section has a scheduled visit enabled
     */
    isScheduledVisitEnabled() {
        return this.scheduledVisit.enabled;
    }

    /**
     * Obtiene la configuración de la visita programada de la sección
     *
     * @returns {Object} Objeto de definición de visita programada
     */
    getScheduledVisit() {
        return this.isScheduledVisitEnabled()
            ? this.scheduledVisit
            : null;
    }

    /**
     * Obtiene la configuración de notificaciones asociadas a la visita programada de la sección
     *
     * @returns {Object[]} Objetos de definición de notificación
     */
    getVisitNotifications() {
        return this.isScheduledVisitEnabled()
            ? this.scheduledVisit.notifications.filter(notification => !!notification.enabled)
            : [];
    }

    /**
     *
     * @param {number} id Notification ID
     *
     * @returns {Object} Notification definition
     */
    getVisitNotification(id) {
        return this.getVisitNotifications().find(notification => notification.id === id) || null;
    }
}

module.exports = Section;
